module.exports = __webpack_public_path__ + "static/media/board_view_campus_img_1220.52a510f0.png";